import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'

const NUMBER_LENGTH = 50
const BASE_LENGTH = 200

export const overestimationShema = Joi.object({
  dealsIds: Joi.array().items(
    Joi.object({
      dealId: Joi.any(),
      estimatedValue: Joi.number()
        .max(99999999.99)
        .min(0.1)
        .required()
        .unsafe()
        .error(errorsResolver({
          numberMin: 'Сумма оценки должна быть больше 0',
          required: `Сумма оценки обязательное поле`,
          numberBase: `Сумма оценки обязательное поле`,
          numberMax: `Сумма оценки должна быть меньше 99999999.99`
        })),
      totalEstimatedValue: Joi.number(),
      totalToPay: Joi.number()
    })
  ),
  documentNumber: Joi.string()
    .max(NUMBER_LENGTH)
    .pattern(new RegExp('^[0-9\\-]{1,50}$'))
    .empty('')
    .error(errorsResolver({
      max: `Переоценка должна быть до ${NUMBER_LENGTH} символов`,
      pattern: 'Переоценка должна быть числом',
    })),
})

export const overestimationBaseShema = Joi.object({
  dealsIds: Joi.array().items(
    Joi.object({
      dealId: Joi.any(),
      estimatedValue: Joi.number()
        .max(99999999.99)
        .min(0.1)
        .required()
        .empty('')
        .unsafe()
        .error(errorsResolver({
          required: `Сумма оценки обязательное поле`,
          numberMin: 'Сумма оценки должна быть больше 0',
          numberBase: `Допустим ввод только цифр и точки`,
          numberMax: `Сумма оценки должна быть меньше 99999999.99`
        })),
      totalEstimatedValue: Joi.number(),
      totalToPay: Joi.number()
    })
  ),
  documentNumber: Joi.string()
    .max(NUMBER_LENGTH)
    .pattern(new RegExp('^[0-9\\-]{1,50}$'))
    .empty('')
    .error(errorsResolver({
      max: `Переоценка должна быть до ${NUMBER_LENGTH} символов`,
      pattern: 'Переоценка должна быть числом',
    })),
  base: Joi.string()
    .max(BASE_LENGTH)
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.,№\\- ]{1,200}$'))
    .empty('')
    .error(errorsResolver({
      max: `Основание должно быть до ${BASE_LENGTH} символов`,
      pattern: 'Основание содержит некорректные символы',
    })),
})